import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
import { ref } from "../../../../../adapter-vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'message-abstract-text',
  props: {
    content: {
      type: Array,
      "default": []
    },
    highlightType: {
      type: String,
      "default": "font" // "font":字体高亮 "background":背景高亮
    },
    displayType: {
      type: String,
      "default": "info" // "info":信息展示形式 "bubble": 气泡展示形式
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var contentText = ref(props.content);
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(['message-abstract-text', "message-abstract-text-".concat(__props.highlightType), "message-abstract-text-".concat(__props.displayType)])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contentText), function (contentItem, index) {
        return _openBlock(), _createElementBlock("span", {
          key: index,
          "class": _normalizeClass([contentItem && contentItem.isHighlight ? 'highlight' : 'normal'])
        }, _toDisplayString(contentItem.text), 3);
      }), 128))], 2);
    };
  }
});